import { Cookies } from "react-cookie";
import { getSiteDomain } from "@/utils/site";
import { AUTHORIZATION } from "@/internals/constants/cookies";
import { PATHS } from "@/internals/constants/paths";
import { TokenData } from "./types";
import { isJwtTokenExpired } from "@/utils/tokenUtils";

export const setCookie = (name: string, value: any, expiration?: Date) => {
  const cookies = new Cookies();
  cookies.set(name, value, {
    domain: getCookieDomain(),
    expires: expiration ? new Date(expiration) : undefined,
    path: PATHS.HOME,
  });
};

export const getCookie = (name: string): unknown | undefined => {
  try {
    const cookies = new Cookies();
    return cookies.get(name);
  } catch (error) {
    console.error("Error getting cookie:", error);
    return undefined;
  }
};

// TODO: QR-6185 - Refactor > Remove this method and use getCookie instead
export const getAuthCookie = () => {
  const cookies = new Cookies();
  return cookies.get(AUTHORIZATION);
};

export const removeCookie = (name: string) => {
  const cookies = new Cookies();
  cookies.remove(name, { path: PATHS.HOME, domain: getCookieDomain() });
};

export const setAuthCookie = (token: string, expiration?: string) => {
  const cookies = new Cookies();

  cookies.set(AUTHORIZATION, token, {
    domain: process.env.NEXT_PUBLIC_ENV === "prod" ? getCookieDomain() : undefined,
    expires: expiration ? new Date(expiration) : undefined,
    path: PATHS.HOME,
  });
};

// TODO: QR-6185 - Refactor > Remove this method and use removeCookie instead
export const removeAuthCookie = () => {
  const cookies = new Cookies();
  cookies.remove(AUTHORIZATION, { path: PATHS.HOME });
  cookies.remove(AUTHORIZATION, { domain: getSiteDomain(), path: PATHS.HOME });
};

export const getTokenData = (): TokenData => {
  const cookies = new Cookies();
  const token = cookies.get(AUTHORIZATION);

  if (!token) return undefined;

  return {
    token,
    isTokenExpired: isJwtTokenExpired(token),
  };
};

export const isUserLoggedIn = () => {
  const cookies = new Cookies();
  return cookies.get(AUTHORIZATION);
};

export const getCookieDomain = () => {
  return `.${getSiteDomain()}`;
};
